export default __webpack_public_path__ + "static/sugamo-20130414-DSC01057-resize-w2000-86d0469aeeb98bac9c1847ba9a0a0f8f.jpg";